
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .q-pa-lg(style="width: 500px")
    q-field.people-detail-field.q-mb-md(
      :error="errors.person_code !== false"
      :error-label="errors.person_code || ''"
    )
      QSelectMod(
        v-model="data.person_code"
        :options="personOptions"
        float-label="個人"
      )

    q-field.people-detail-field.q-mb-md(
      :error="errors.task_code !== false"
      :error-label="errors.task_code || ''"
    )
      QSelectMod(
        v-model="data.task_code"
        :options="taskOptions"
        float-label="割当"
      )

    //- 更新モード
    template(v-if="data.id")
      .flex.justify-end
        q-btn.q-mx-sm(
          color="negative"
          flat
          @click="destroy"
        ) 削除

        q-btn.q-mx-sm(
          color="primary"
          flat
          @click="confirm"
        ) 更新

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

    //- 新規モード
    template(v-else)
      .flex.justify-end
        q-btn.q-mx-sm(
          color="primary"
          flat
          @click="confirm"
        ) 追加

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

</template>

<script>
import {get} from 'lodash-es'

import QSelectMod from 'components/QSelectMod'
import AxiosMixin from 'mixins/axios'

const defaults = {
  id:          null,
  person_code: '',
  task_code:   '',
}

export default {
  components: {QSelectMod},
  mixins: [AxiosMixin],

  data() {
    return {
      visible:  false,

      data:     {},
      original: null,

      personOptions: [],
      taskOptions: [],

      errors: {
        person_code: false,
        task_code:   false,
      },
    }
  },

  methods: {

    preventIllegalNumberCharacter(e) {
      if(e.key == 'e') {
        e.preventDefault()
      }
    },

    show(people, tasks, data = {}) {
      const personOptions = people
        .map((v) => ({ label: `${v.name}`, value: v.person_code }))
        .sort((a, b) => a.value.localeCompare(b.value))
      this.personOptions = personOptions

      this.taskOptions = tasks
        .filter((v) => 100 <= v.task_code)
        .map((v) => ({ label: `${v.name}`, value: v.task_code }))
        .sort((a, b) => Math.sign(Number(a.value) - Number(b.value)))

      this.data = Object.entries(defaults).reduce(
        (a, [k, v]) => ({...a, [k]: get(data, k, v)}), {})
      this.original = {...this.data}

      this.clearError()
      this.visible = true
    },

    hide() {
      this.visible = false
    },

    confirm() {
      this.clearError()
      this.$emit('confirm', this.data)
    },

    async destroy() {
      try {
        await this.$q.dialog({
          title:   '削除の確認',
          message: '項目を削除します。よろしいですか？',
          ok:      {label: '削除',       color: 'negative'},
          cancel:  {label: 'キャンセル', color: 'dark', flat: true},
        })
        this.$emit('delete', this.data)
      }
      catch(e) {this.$handler(e)}
    },

    clearError() {
      this.errors = Object.keys(this.errors).reduce(
        (a, k) => ({...a, [k]: false}), {})
    },

    handler(e) {
      this.$handler(e, errors => {
        this.errors = Object.entries(this.errors).reduce(
          (a, [k, v]) => ({...a, [k]: get(errors, [k, '0'], v)}), {})
      })
    },
  },
}
</script>

<style lang="sass">
.people-detail-field
  height: 5rem
</style>
